export default {
  MyPropertiesHeading: "My Properties",
  PropertiesEmptyStateHeading: "No Properties Found",
  PropertiesEmptyState: "This profile does not have any properties currently associated. Please contact support for assistance",
  GroupPropertiesEmptyStateHeading: "No properties to see",
  GroupPropertiesEmptyStateDescription: "Contact your property manager if there should be properties displayed in this group",
  GroupIndividualPropertiesHeader: "Individual Properties"
};
